module.exports = __webpack_public_path__ + "static/media/147.93847fa4.mp3";